import { createAction } from 'redux-actions'
import { message } from 'antd'
import yoyi from 'src/helpers/fetch/fetchService'
import { hasChildren } from 'src/utils/format'
import { labelList, labelTotal } from 'src/api/labelMarket'
import { labelPublish, labelUnpublish, labelUnsync, labelSync } from 'src/api/labelPublish'
import { getArray } from 'utils';
import { dispatchAsync } from 'src/utils/fetch';
import { useApiSelector } from 'src/hooks/useApiSelector';

const apis = useApiSelector();

export enum LabelRequestUrl {
    LEVEL1_LABEL = 'lableMarket/getLabelMeta',
    LEVEL2_LABEL = 'lableMarket/getFirstAndSecond',
    SUB_LABEL = 'lableMarket/getLabelUserCnt',
    
    TREND = 'lableMarket/getTrendingSearch',
    SUM = 'lableMarket/getSumNum',
    SEARCH = 'lableMarket/search',
    SUBMIT_LABEL = 'labelRelease/insert',
    CANCLE_LABEL = 'labelRelease/delete',
}

export const RECEIVE_ROOT_LIST_DATA = 'RECEIVE_ROOT_LIST_DATA'
export const GET_LABEL_INFO_LOADING = 'GET_LABEL_INFO_LOADING'
export const RECEIVE_USER_NUM = 'RECEIVE_USER_NUM'

export const getLabelInfoLoading = createAction(GET_LABEL_INFO_LOADING)
export const receiveRootListData = createAction(RECEIVE_ROOT_LIST_DATA)
export const receiveUserNum = createAction(RECEIVE_USER_NUM)

export const fetchRootList = ({groupType, ...others}) => async (dispatch) => {
    try {
        dispatch(getLabelInfoLoading(true))
        const nresponse: any[] = await labelList({ type: groupType, ...others })
        .then(res => getArray(res, 'records'))
        nresponse.forEach(item => {
            const id = item.metaId
            item.id = id
            item.release = item.isRelease
            item.children = []
            item.idChain = id
            item.rootId = id
            item.level = 1
            item.levelChain = 1
        })
        const total = await labelTotal(groupType) 
        const user = { bizdate: 0, num: total }
        dispatch(receiveUserNum(user))

        dispatch(receiveRootListData(nresponse))
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}

export const fetchSubLabel = payload => async (dispatch, getState) => {
    try {
        dispatch(getLabelInfoLoading(true))
        // const {data} = await yoyi.get(LabelRequestUrl.SUB_LABEL, payload)

        const data = await labelList({ 
            type: payload.groupType,
            metaId: payload.metaId,
            pid: payload.labelPId,
            level: payload.level + 1,
            pageNum: payload.pageNum || 1,
            pageSize: payload.pageSize || 20
        })
        .then(res => getArray(res, 'records'))

        data.forEach(item => {
            item.id = item.labelId
            item.release = item.isRelease
        })
        const withChildrenData = hasChildren(data)
        const rootList = getState().labelPublish.rootList
        const {metaId, level} = payload
      
        if(level) {
            const loop = (rootList) => {
                if(!rootList) return
                rootList.some((item)=>{
                    if( item.rootId == metaId && item.levelChain == payload.levelChain && item.idChain == payload.idChain ){
                        item.children = withChildrenData.map(ele=>{
                            ele.rootId = item.rootId;
                            ele.idChain = item.idChain + '-' + ele.id
                            ele.levelChain = item.levelChain + '-' + ele.level;
                            return ele
                        })
                    } else if( item.children ) {
                        loop(item.children)
                    }
                })
            }
            loop(rootList)
        }
        dispatch(receiveRootListData(rootList))
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}

export const submitLabel = payload => async (dispatch, getState) => {
    try {
        const { metaId, labelId, name, groupType } = payload
        dispatch(getLabelInfoLoading(true))
        const response: {code: Number} = await labelPublish({ metaId, labelId })
        if(response.code === 10000){
            message.success(`发布标签 ${name} 成功`)
            // dispatch(fetchRootList({groupType}))
        }
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}

export const cancelLabel = payload => async (dispatch, getState) => {
    try {
        const { metaId, labelId, name, level, groupType } = payload
        dispatch(getLabelInfoLoading(true))
        const response: {code: Number} = await labelUnpublish({metaId, labelId})

        if(response.code === 10000){
            message.success(`取消标签 ${name} 成功`)
            // dispatch(fetchRootList({groupType}))
        }
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}

export const cancelLabelSync = payload => async (dispatch, getState) => {
    try {
        const { metaId, labelId, name, level, groupType } = payload
        dispatch(getLabelInfoLoading(true))
        const response: {code: Number} = await labelUnsync({metaId, labelId})

        if(response.code === 10000){
            message.success(`取消同步引擎 ${name} 成功`)
            // dispatch(fetchRootList({groupType}))
        }
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}


export const submitLabelSync = payload => async (dispatch, getState) => {
    try {
        const { metaId, labelId, name, groupType } = payload
        dispatch(getLabelInfoLoading(true))
        const response: {code: Number} = await labelSync({ metaId, labelId })
        if(response.code === 10000){
            message.success(`同步引擎 ${name} 成功`)
            // dispatch(fetchRootList({groupType}))
        }
    } catch (e) {
        yoyi.exceptionMessage(e)
    } finally {
        dispatch(getLabelInfoLoading(false))
    }
}

export const submitLabelThird = payload => async (dispatch, getState) => {
    const { metaId, labelId } = payload
    dispatch(getLabelInfoLoading(true))
    const { error } = await dispatchAsync(apis.labelPublishApis.saveSyncTripart({ metaId, labelId }))
    dispatch(getLabelInfoLoading(false))
    if (error) {
        yoyi.exceptionMessage(error)
    }
    message.success(`三方同步 ${name} 成功`)
}

export const cancelLabelThird = payload => async (dispatch, getState) => {
    const { metaId, labelId } = payload
    dispatch(getLabelInfoLoading(true))
    const { error } = await dispatchAsync(apis.labelPublishApis.cancelSyncTripart({ metaId, labelId }))
    dispatch(getLabelInfoLoading(false))
    if (error) {
        yoyi.exceptionMessage(error)
    }
    message.success(`取消三方同步 ${name} 成功`);
}